import { Controller } from '@hotwired/stimulus'

import getPreciseDistance from 'geolib/es/getPreciseDistance';

export default class extends Controller {
  static get targets() {
    return [ 'clock', 'dialog', 'text' ]
  }

  connect() {
    this.scheduleRefresh()
    this.goToClock()
  }

  toggle(e) {
    e.preventDefault()
    this.cancelRefresh()

    if (confirm(this.data.get('confirmation'))) {
      this.determineLocation()
    } else {
      this.scheduleRefresh()
    }
  }

  fail(message) {
    this.goToClock()
    alert(message)
    this.scheduleRefresh()
  }

  determineLocation() {
    this.goToDialog()
    if (!this.hasCoordinates()) {
      this.submitToggleRequest()
    } else if(!navigator.geolocation) {
      this.fail('Het bepalen van uw locatie is mislukt. Staat u alstublieft het delen van uw locatie toe.')
    } else {
      if (confirm(this.data.get('confirmation-location'))) {
        navigator.geolocation.getCurrentPosition(this.locationSuccess.bind(this), this.locationError.bind(this));
      }
    }
  }

  locationSuccess(position) {
    this.submitToggleRequest(position)
  }

  locationError() {
    this.submitToggleRequest()
  }

  submitToggleRequest(position = null) {
    let distance = this.computeDistance(position)
    var request = new XMLHttpRequest()
    var data = new FormData()

    if (!this.validateDistance(distance)) {
      this.fail('Inklokken mislukt; zorg dat u binnen een afstand van ' + this.limitValue + ' meter van de projectlocatie bent.')
      return
    }

    data.append('distance_in_meters', distance)

    request.open('PATCH', this.data.get('url'))
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    request.onload = () => {
      if (request.status === 200) {
        this.finishToggle()
      } else {
        alert('Het verwerken van uw verzoek om in/uit te klokken is mislukt.')
      }
    }
    request.send(data)
  }

  finishToggle() {
    location.reload()
  }

  validateDistance(distance) {
    console.log(distance)
    console.log(this.limit())
    return distance === null ||
        this.limit() === null || this.limit() == 0 ||
        distance < this.limit()
  }

  computeDistance(position) {
    if (position == null) { return null }
    if (!this.hasCoordinates()) { return null }

    let latitude = parseFloat(this.data.get('latitude'))
    let longitude = parseFloat(this.data.get('longitude'))

    return getPreciseDistance(
      { latitude: latitude, longitude: longitude },
      { latitude: position.coords.latitude, longitude: position.coords.longitude }
    )
  }

  hasCoordinates() {
    return this.data.has('latitude') &&
        this.data.has('longitude') &&
        this.data.get('latitude') !== '' &&
        this.data.get('longitude') !== ''
  }

  goToClock() {
    this.clockTarget.style.display = 'block'
    this.dialogTarget.style.display = 'none'
  }
  goToDialog() {
    this.clockTarget.style.display = 'none'
    this.dialogTarget.style.display = 'block'
  }

  scheduleRefresh() {
    this.timer = setTimeout(this.refresh, 60000)
  }
  cancelRefresh() {
    clearTimeout(this.timer)
    this.timer = null
  }
  refresh() {
    this.timer = null
    location.reload()
  }

  limit() {
    if (!this.data.has('limit')) { return null }

    return parseFloat(this.data.get('limit'))
  }
}
